import { useState } from "preact/hooks";

import { Form } from "@components/kit/form";
import { PageHeader } from "@components/kit/page-header";
import { Button } from "@components/ui/interactive/button";
import { Container } from "@components/ui/structure/container";
import { LoadingView } from "@components/view/loading-view";
import { usePermissionManagement } from "@contexts/permission-management";
import { useClasses } from "@styles";

export function PermissionManagementView() {
  const { ready, create } = usePermissionManagement();
  const [name, setName] = useState<string>("");

  if (!ready)
    return <LoadingView />

  return (<>
    <Container className={useClasses("um-content")}>
      <PageHeader
        icon="LockRegular"
        title="Permission Management"
      />

      <Container className={useClasses("um-layout")}>
        <Form
          fields={[
            {
              label: "Permission Name",
              type: "tel",
              value: name,
              updateValue: (value) => setName(value),
            },
          ]}
        />

        <Button
          icon="KeyPlusRegular"
          title="Create Permission"
          hoverText="Create New Permission"
          disabled={!name}
          onClick={() => create(name)}
        />
      </Container>
    </Container>
  </>);
}

